import React from 'react'
import StatsCard from "../components/Hero";
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div>
        
      
      <StatsCard />
      <Footer />
    </div>
  )
}

export default Home